import request from '@/lib/request/'

const baseUri = 'news/'

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function postSort (data) {
  return request({
    url: baseUri + 'sort',
    method: 'post',
    data
  })
}

/**
 * @param data {Object} form data
 * @returns {Promise}
 */
export function post (data) {
  return request({
    url: baseUri,
    method: 'post',
    data
  })
}

/**
 * @param data {Object} form data
 * @param id {Number}
 * @returns {Promise}
 */
export function put (data, id) {
  return request({
    url: baseUri + id,
    method: 'put',
    data
  })
}

/**
 * @param id {Number}
 * @returns {Promise}
 */
export function getDetail (id) {
  return request({
    url: baseUri + id,
    method: 'get'
  })
}

/**
 * @param id {Number}
 * @returns {Promise}
 */
export function del (id) {
  return request({
    url: baseUri + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/press/index.js